import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import UpliftCss from "../common/upliftcss.module.css";

const CustomMobileCard = ({ tableData, columns, initialSortBy = [], onSort, sortDescFirst = true, defaultSortField = "modificationDate", defaultSortDirection = "desc" }) => {
	const [isRTL, setIsRTL] = useState(JSON.parse(localStorage.getItem("isRTL")) || false);
	const [t, i18n] = useTranslation();
	const [sortBy, setSortBy] = useState(initialSortBy);

	const initialRenderRef = React.useRef(true);
	const prevSortByRef = React.useRef(initialSortBy);
	const getSortIndicator = (col) => {
		if (sortBy[0]?.id !== col.accessor) {
			// return <span className={` ${UpliftCss.sortingArrowns}`}>▲▼</span>;
			return;
		} else {
			// faint double arrow for unsorted columns
			return <span className={` ${UpliftCss.sortedArrown}`}>{sortBy[0].desc ? " ▼" : " ▲"}</span>;
		}
		//return sortBy[0].desc ? " ▼" : " ▲";
	};
	useEffect(() => {
		// Skip the effect on the initial render
		if (initialRenderRef.current) {
			initialRenderRef.current = false;
			return;
		}

		if (onSort && sortBy.length === 0) {
			// Reset to default sort
			onSort(defaultSortField, defaultSortDirection);
			return;
		}

		// Only trigger onSort if sortBy has actually changed
		if (onSort && sortBy.length > 0) {
			const { id, desc } = sortBy[0];

			// Check if sort state has actually changed
			const prevSort = prevSortByRef.current;
			const prevId = prevSort.length > 0 ? prevSort[0].id : null;
			const prevDesc = prevSort.length > 0 ? prevSort[0].desc : null;

			if (id !== prevId || desc !== prevDesc) {
				// Update the ref to the current sort state
				prevSortByRef.current = sortBy;
				// Call the sort handler
				onSort(id, desc ? "desc" : "asc");
			}
		}
	}, [sortBy, onSort, defaultSortField, defaultSortDirection]);

	return (
		<>
			<Container>
				<Row>
					<Col>
						{columns.map((col, index1) => (
							<div key={index1} style={{ display: "inline" }}>
								{!col.showMobile ? (
									<>{/* <span className={` ${UpliftCss.sortBubles}`}>{col.Header}</span> */}</>
								) : (
									<button
										onClick={() => {
											setSortBy((prev) => {
												if (prev[0]?.id === col.accessor) {
													return [{ id: col.accessor, desc: !prev[0].desc }];
												}
												// New column → use sortDescFirst
												return [{ id: col.accessor, desc: sortDescFirst }];
											});
										}}
										className={` ${UpliftCss.sortBubles}`}
									>
										{col.Header}
										{getSortIndicator(col)}
									</button>
								)}
							</div>
						))}
					</Col>
				</Row>
			</Container>
			{tableData.map((item, index) => (
				<div
					key={index} // or another unique key from your data
					className={` ${UpliftCss.fontSize14} card mb-3  shadow-sm overflow-hidden`}
				>
					<Container>
						<Row className="p-2" style={{ backgroundColor: "#f1f1f1" }}>
							{columns
								.filter((col) => col.isTop)
								.map((col, index2) => (
									<Col
										key={col.accessor}
										md={6}
										sm={6}
										xs={6}
										style={
											index2 % 2 === 0
												? { color: "black" } // e.g. first col in row
												: isRTL
												? { textAlign: "left" }
												: { textAlign: "right" }
										}
									>
										{col.accessor === "status" ? (
											<>{item[col.accessor] && <span className={` ${UpliftCss.cardStatus}`}>{item[col.accessor]}</span>}</>
										) : col.accessor === "generatedEmanifestID" ? (
											<span style={item.rowStyle}>
												{col.Header + ": "}
												{item.generatedEmanifestID}
											</span>
										) : (
											<>
												<span className={` ${UpliftCss.cardStatus}`}>
													{col.Header}
													{item[col.accessor]}
												</span>
											</>
										)}
									</Col>
								))}
						</Row>
						{/* Body Section - Fields with isTop: false (in pairs of 2 per row) */}
						{columns
							.filter((col) => !col.isTop && col.accessor !== "action")
							.reduce((rows, col, idx, arr) => {
								if (idx % 2 === 0) rows.push([col]);
								else rows[rows.length - 1].push(col);
								return rows;
							}, [])
							.map((row, rowIndex) => (
								<Row key={rowIndex} className="p-2 pb-0" style={{ backgroundColor: "#ffffff" }}>
									{row.map((col) => (
										<Col key={col.accessor} md={6} sm={6} xs={12} style={isRTL ? { textAlign: "right" } : { textAlign: "left" }}>
											<strong>{col.Header}: </strong>
											{item[col.accessor] || ""}
										</Col>
									))}
								</Row>
							))}

						{/* Optional Action Footer */}
						{columns.find((col) => col.accessor === "action") && item.action && (
							<Row className="p-2" style={isRTL ? { textAlign: "right" } : { textAlign: "left" }}>
								<Col md={12} sm={12} xs={12}>
									{item.action}
								</Col>
							</Row>
						)}
					</Container>
				</div>
			))}
		</>
	);
};
export default CustomMobileCard;
